import { FunctionComponent } from 'react';
import { Modal, Image} from 'react-bootstrap';
import cn from 'classnames';
import styles from "./AddUpdateRole.module.css";
import CustomButton, { ButtonRadiusSize, ButtonSize, ButtonType } from '../../../../../../../component/common/CustomButton/CustomButton';
import FormField, { IFieldTheme, IFieldType } from '../../../../../../../component/common/FormField/FormField';
import FormSelect from '../../../../../../../component/common/FormField/FormSelect';
import { ASSESTS } from '../../../../../../../constant/assest';

interface IProps {
    showModal: boolean;
    title: string;
    onClose: () => void;
    className?: string;
};

const AddUpdateRole: FunctionComponent<IProps> = ({title, showModal, onClose, className}) => {
  return (
    <Modal 
        show={showModal} 
        className={cn(styles.addModal, className)}
        dialogClassName={styles.addModalDialog}
        contentClassName={styles.addModalContent}
        centered={true}
    >
        <CustomButton
            className={styles.modalCloseBtn}
            btnType={ButtonType.IMAGE}
            onClick={onClose}
        >
            <Image src={ASSESTS.CLOSEPOPUP}  alt="Close" />
        </CustomButton>
        <Modal.Header bsPrefix={styles.header}>
          <Modal.Title bsPrefix={styles.title} as={'div'}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix={styles.body}>
            <div className={styles.formTwoCol}>
                <div className={styles.formCol}>
                    <FormField 
                        label={'Roll Name'}
                        placeholder='Enter Roll Name'
                        fieldType={IFieldType.TEXT}
                        fieldTheme={IFieldTheme.LIGHT}
                    />
                </div>
            </div>
            <div className={styles.fullField}>
                <FormSelect
                    label={'Permissions'}
                    placeholder='Select Permission'
                    fieldTheme={IFieldTheme.LIGHT2}
                >
                    <option value="Access1">Access 1</option>
                    <option value="Access2">Access 2</option>
                    <option value="FullAccess3">Full Access</option>
                </FormSelect>
            </div>
        </Modal.Body>
        <Modal.Footer bsPrefix={styles.footer}>
            <CustomButton
                className={styles.addMoreBtn}
                btnType={ButtonType.LIGHTBLUE}
                btnRadius={ButtonRadiusSize.SMALL}
                onClick={onClose}
            >
                Cancel
            </CustomButton>
            <CustomButton
                className={styles.addBtn}
                btnType={ButtonType.GREEN}
                btnRadius={ButtonRadiusSize.SMALL}
            >
                Create Role
            </CustomButton>
        </Modal.Footer>
    </Modal>
  );
}

export default AddUpdateRole;